import { render, staticRenderFns } from "./Medios.vue?vue&type=template&id=58390a8f&"
import script from "./Medios.vue?vue&type=script&lang=js&"
export * from "./Medios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports